module.exports = __webpack_public_path__ + "static/media/80_WAX.bf8f6a8a.webp";